import { combineReducers } from 'redux'
import mainReducer from './reducers'
import userManagementReducer from '../user-management/reducers'
import registerReducer from '../register/reducers'
import locationsReducer from '../locations/reducers'
import customersReducer from '../customers/reducers'
import devicesReducer from '../devices/reducers'
import sharingReducer from '../sharing/reducers'
import reportsReducer from '../reports/reducers'
import apiKeysReducer from '../api-keys/reducers'
import detachedSharingReducer from '../sharing-detached/reducers'
import dashboardReducer from '../dashboard/reducers'
import mailReducer from './components/common/reports-table/reducers'
import networkDevicesReducer from '../network-devices/reducers'
import hotSwapReducer from '../hot-swap/reducers'

const rootReducer = combineReducers({
    main: mainReducer,
    userManagement: userManagementReducer,
    register: registerReducer,
    locations: locationsReducer,
    customers: customersReducer,
    devices: devicesReducer,
    networkDevices: networkDevicesReducer,
    dashboard: dashboardReducer,
    sharing: sharingReducer,
    reports: reportsReducer,
    apiKeys: apiKeysReducer,
    detachedSharing: detachedSharingReducer,
    mail: mailReducer,
    hotswap: hotSwapReducer
})

export default rootReducer
